import React from 'react';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { Popover } from '@fiverr-private/fit';
import { mixpanel } from '@fiverr-private/obs';
import { EducationTooltip } from '@fiverr-private/orca';
import { baseTranslationButtonProps } from '../../../utils/props';
import { MixpanelEventTypes } from '../../../utils/events/mixpanel/types';
import LeanToggledTranslationButton from '../LeanToggledTranslationButton';
import withTranslationButtonWrapper from '../TranslationButtonWrapper';

const { POSITIONS } = Popover;

const TranslationButtonWithEducation = (props) => {
    const { locale } = getContext();

    const reportEducationOpen = () => {
        mixpanel.track(MixpanelEventTypes.education.educationTooltipShow);
    };

    const { i18n } = props;
    const language = i18n.t(`languages.${locale}`);

    return (
        <EducationTooltip title={<I18n k="machine_translation.education.title" params={{ language }}/>}
            body={<I18n k="machine_translation.education.body" params={{ language }}/>}
            badgeTitle={<I18n k="machine_translation.education.badge"/>}
            closeTitle={<I18n k="machine_translation.education.close"/>}
            onOpen={reportEducationOpen}
            position={POSITIONS.BOTTOM}
            tooltipStorageKey="mt_cta_education_tooltip_v2">
            <LeanToggledTranslationButton {...props}/>
        </EducationTooltip>
    );
};

TranslationButtonWithEducation.propTypes = baseTranslationButtonProps;

export default withTranslationButtonWrapper(TranslationButtonWithEducation);
